import { css } from '@repo/pandacss/css';
import type { KeyboardEvent } from 'react';
import type { StepType } from '@/features/funnel/config/types';

/** Box-less wrapper so `<fieldset disabled>` can lock answer controls without affecting layout. */
export const pendingFieldsetClass = css({ display: 'contents' });

export const ERROR_MESSAGE_BY_TYPE: Record<StepType, string> = {
  'single-select': 'Please pick an option to continue.',
  'multi-select': 'Please select at least one option to continue.',
  'searchable-grouped-multi-select': 'Please select at least one option to continue.',
  'number-input': 'Please enter a valid number to continue.',
};

export function getFunnelStepFormId(stepId: string) {
  return `funnel-step-${stepId}`;
}

/**
 * Enter should only submit the funnel when focus is on the Next button.
 * All other elements activate in place: checkboxes/radios toggle, text inputs do nothing.
 */
export function handleFunnelFormEnterKey(event: KeyboardEvent<HTMLFormElement>) {
  if (event.key !== 'Enter') return;

  const target = event.target;
  if (!(target instanceof HTMLElement)) return;

  // Submit, Skip, clear-search, suggestion pills, chip remove — native button activation.
  if (target.tagName === 'BUTTON') return;

  event.preventDefault();

  if (
    target instanceof HTMLInputElement &&
    (target.type === 'checkbox' || target.type === 'radio') &&
    !target.disabled
  ) {
    target.click();
  }
}
